function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export var selectNewTheme = {
  baseStyle: _ref => {
    var {
      hasCustomValue
    } = _ref;
    return {
      trigger: {
        position: 'absolute',
        inset: '0',
        opacity: '0',
        cursor: 'pointer'
      },
      triggerValue: _objectSpread({
        display: 'flex',
        alignItems: 'center',
        pointerEvents: 'none'
      }, hasCustomValue && {
        '&.small': {
          minHeight: '40px'
        },
        '&.large': {
          minHeight: '48px'
        }
      }),
      placeholder: {
        color: 'neutral.dark',
        display: 'flex',
        minWidth: 0,
        _disabled: {
          color: 'neutral.light'
        }
      },
      triggerRightElement: {
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        pointerEvents: 'none',
        paddingRight: 's',
        paddingLeft: 'xs',
        color: 'neutral.black',
        _disabled: {
          cursor: 'default'
        },
        _readOnly: {
          cursor: 'default'
        },
        _loading: {
          cursor: 'default'
        },
        '&[data-view-mode="true"]': {
          display: 'none'
        }
      },
      clearButton: {
        top: '50%',
        transform: 'translateY(-50%)',
        display: 'flex',
        marginRight: 'xl',
        marginLeft: 'xs'
      },
      option: {
        display: 'flex',
        width: '100%',
        padding: 's',
        cursor: 'pointer',
        transition: 'background-color 0.1s',
        textStyle: 'body3',
        color: 'neutral.black',
        outline: 'transparent solid 2px',
        _hover: {
          backgroundColor: 'neutral.lightest'
        },
        _active: {
          backgroundColor: 'neutral.lightest'
        },
        _disabled: {
          color: 'neutral.light',
          backgroundColor: 'transparent',
          cursor: 'not-allowed'
        }
      },
      emptyState: {
        textAlign: 'center',
        color: 'neutral.darker',
        padding: 's'
      },
      searchBar: {
        paddingX: 's',
        paddingTop: 's'
      }
    };
  }
};
//# sourceMappingURL=SelectNew.theme.js.map